import SuperRepository from '../superRepository'

export default new (class SpendsParsingLogRepository extends SuperRepository {
  baseUri() {
    return 'google_parse_result'
  }
  downloadFile = id => this.httpClient().getFile(`${this.baseUri()}/${id}/get_file`)
  exportSpendsParsingLogToken = (data, params) =>
    this.reportHttpClient().postQuery('export/google_parse_result/token', data, params)
})()
